var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20H19C19.55 20 20 20.45 20 21C20 21.55 19.55 22 19 22H5C4.45 22 4 21.55 4 21C4 20.45 4.45 20 5 20ZM5 2H19C19.55 2 20 2.45 20 3C20 3.55 19.55 4 19 4H5C4.45 4 4 3.55 4 3C4 2.45 4.45 2 5 2ZM13 9H14.79C15.24 9 15.46 8.46 15.14 8.15L12.35 5.36C12.15 5.16 11.84 5.16 11.64 5.36L8.85 8.15C8.7809 8.2205 8.73421 8.30987 8.71582 8.40686C8.69743 8.50384 8.70816 8.60411 8.74665 8.69501C8.78515 8.7859 8.8497 8.86337 8.93215 8.91765C9.01461 8.97193 9.11129 9.00058 9.21 9H11V15H9.21C8.76 15 8.54 15.54 8.86 15.85L11.65 18.64C11.85 18.84 12.16 18.84 12.36 18.64L15.15 15.85C15.2185 15.7801 15.265 15.6917 15.2837 15.5956C15.3025 15.4995 15.2926 15.4001 15.2553 15.3096C15.2181 15.2191 15.155 15.1415 15.0741 15.0865C14.9932 15.0314 14.8979 15.0014 14.8 15H13V9Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.231e97fbcc104181399ed68a39f79a41.svg";
export { ForwardRef as ReactComponent };